import { inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { TeacherApiService, CourseLevelApiService } from '@shared/services';
import { FormConfig } from '../edit-create-form.interfaces';
import { TEACHER_SELECT_CONFIG, TRAINING_TYPE_SELECT_CONFIG, TRAINING_STATUS_SELECT_CONFIG, COURSE_LEVEL_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const teacherLevelFormPopoverConfig = (): FormConfig => {
  const teacherApiService = inject(TeacherApiService);
  const courseLevelApiService = inject(CourseLevelApiService);

  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'teacherId', label: 'Giáo viên', required: true, width: '2/3',
        type: 'select', config: { ...TEACHER_SELECT_CONFIG, service: teacherApiService },
        disabled: (editMode) => editMode
      },
      {
        key: 'type', label: 'Loại đào tạo', required: true, width: '1/3',
        type: 'select', config: { ...TRAINING_TYPE_SELECT_CONFIG }
      },
      {
        key: 'courseLevelId', label: 'Cấp độ', required: true, width: '1/3',
        type: 'select', config: { ...COURSE_LEVEL_SELECT_CONFIG, service: courseLevelApiService }
      },
      {
        key: 'status', label: 'Trạng thái', required: true, width: '1/3',
        type: 'select', config: { ...TRAINING_STATUS_SELECT_CONFIG }
      },
      {
        key: 'priority', label: 'Ưu tiên', required: true, width: '1/3',
        type: 'text', placeholder: 'Nhập mức ưu tiên',
        validators: [Validators.pattern(/^\d+$/), Validators.min(0)],
        customErrorMessage: 'Mức ưu tiên phải là số nguyên không âm'
      },
      {
        key: 'note', label: 'Ghi chú', required: false, width: 'full',
        type: 'textarea', placeholder: 'Nhập ghi chú'
      }
    ]
  };
};
